import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

export default function LegalFooter() {
  const { tr } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="legal-footer" className="mt-10 pt-6 border-t border-border/60 text-xs text-muted-foreground">
      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
        <Link to="/terms" className="hover:text-foreground transition-colors" data-testid="footer-terms">{tr("Termini di Servizio", "Terms of Service")}</Link>
        <span className="opacity-40">·</span>
        <Link to="/privacy" className="hover:text-foreground transition-colors" data-testid="footer-privacy">{tr("Privacy Policy", "Privacy Policy")}</Link>
        <span className="opacity-40">·</span>
        <Link to="/cookie" className="hover:text-foreground transition-colors" data-testid="footer-cookie">{tr("Cookie Policy", "Cookie Policy")}</Link>
        <span className="opacity-40">·</span>
        <button type="button" onClick={() => window.dispatchEvent(new Event("open-cookie-preferences"))} className="hover:text-foreground transition-colors" data-testid="footer-cookie-prefs">
          {tr("Preferenze cookie", "Cookie preferences")}
        </button>
      </div>
      <p className="text-center mt-3 opacity-70">Technical Hub — All rights reserved. Confidential</p>
    </footer>
  );
}
